export default {
  base_url: '',
  routes: {
    api_media_post_player_info_and_links: {
      tokens: [
        ['text', '/infos'],
        ['variable', '/', '[a-zA-Z0-9_+\\.=-]+', 'crypttext'],
        ['text', '/video/player_param'],
      ],
      defaults: [],
      requirements: {
        crypttext: '[a-zA-Z0-9_+\\.=-]+',
      },
      hosttokens: [],
    },

    api_media_get_player_attached_file_by_id: {
      tokens: [['variable', '/', '\\d+', 'id'], ['text', '/video/player/download/videofile']],
      defaults: [],
      requirements: {
        id: '\\d+',
      },
      hosttokens: [],
    },

    api_get_rm_live: {
      tokens: [['variable', '/', '\\d+', 'id'], ['text', '/lives/get-rm-live']],
      defaults: [],
      requirements: {
        id: '\\d+',
      },
      hosttokens: [],
    },
    api_post_avg_user_vote_video: {
      tokens: [['text', 'likes_video/average-user-vote-video']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_post_avg_user_vote_live: {
      tokens: [['text', 'likes_live/average-user-vote-live']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_post_vote_by_user_and_video: {
      tokens: [['text', '/likes_video/vote-by-user-and-video']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_post_vote_by_user_and_live: {
      tokens: [['text', '/likes_live/vote-by-user-and-live']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },

    api_media_get_authentification_video: {
      tokens: [['text', '/video/video/authentification']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_media_get_transcription_video: {
      tokens: [['text', '/video/transcription-video']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_media_post_check_if_videos_are_done_transcription: {
      tokens: [['text', '/video/video/are-they-done-transcription']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_media_post_add_rich_media_responses: {
      tokens: [['variable', '/', '\\d+', 'id'], ['text', '/rich_media/add-rich-media-response']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_media_get_live_player_info_and_links: {
      tokens: [
        ['text', '/infos'],
        ['variable', '/', '[a-zA-Z0-9_+\\.=-]+', 'crypttext'],
        ['text', '/video/live/player'],
      ],
      defaults: [],
      requirements: {
        crypttext: '[a-zA-Z0-9_+\\.=-]+',
      },
      hosttokens: [],
    },
    api_mooc_get_stats_options: {
      tokens: [['text', '/mooc/stats-options']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_log: {
      tokens: [['text', '/global/log']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_media_montage_video: {
      tokens: [['text', '/video/montage']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_media_montage_video_player: {
      tokens: [['text', '/video/player/montage']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_media_post_add_comments: {
      tokens: [['text', '/comments/add']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_media_get_video_preview_link: {
      tokens: [['variable', '/', '\\d+', 'id'], ['text', '/video/video/preview-link']],
      defaults: [],
      requirements: {
        id: '\\d+',
      },
      hosttokens: [],
    },
    api_media_generate_tmp_rtc_rich_media_video: {
      tokens: [
        ['variable', '/', '\\d+', 'idVideo'],
        ['text', '/rich_media/generate-tmp-rtc-rich-media-video'],
      ],
      defaults: [],
      requirements: {
        idVideo: '\\d+',
      },
      hosttokens: [],
    },
    api_media_post_edit_comments: {
      tokens: [['variable', '/', '\\d+', 'id'], ['text', '/comments/edit']],
      defaults: [],
      requirements: {
        id: '\\d+',
      },
      hosttokens: [],
    },
    api_media_delete_comments: {
      tokens: [['variable', '/', '\\d+', 'id'], ['text', '/comments/delete']],
      defaults: [],
      requirements: {
        id: '\\d+',
      },
      hosttokens: [],
    },
    api_media_post_enable_comments: {
      tokens: [['variable', '/', '\\d+', 'id'], ['text', '/comments/enable-comments']],
      defaults: [],
      requirements: {
        id: '\\d+',
      },
      hosttokens: [],
    },
    api_media_post_disable_comments: {
      tokens: [['variable', '/', '\\d+', 'id'], ['text', '/comments/disable-comments']],
      defaults: [],
      requirements: {
        id: '\\d+',
      },
      hosttokens: [],
    },
    api_survey_add_response_to_survey_for_video: {
      tokens: [['text', '/survey/add-response-to-survey-for-video']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_media_get_comment_media_by_video: {
      tokens: [
        ['variable', '/', '\\d+', 'id'],
        ['text', '/comments/get-all-comments-media-by-video'],
      ],
      defaults: [],
      requirements: {
        id: '\\d+',
      },
      hosttokens: [],
    },
    api_media_send_video_by_mail_from_player: {
      tokens: [['text', '/video/video/send-video-by-email-from-player']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_media_get_survey_for_video: {
      tokens: [['variable', '/', '\\d+', 'id'], ['text', '/video/get-survey']],
      defaults: [],
      requirements: {
        id: '\\d+',
      },
      hosttokens: [],
    },
    api_media_get_interactivities: {
      tokens: [['text', '/rich_media/get-interactivies']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_media_get_videos_for_mounting: {
      tokens: [['text', '/video/videos/videos-for-mounting']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_media_get_default_video_in_player: {
      tokens: [['text', '/video/videos/default-video-in-player']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_media_get_src_video: {
      tokens: [['text', '/video/videos/video/src']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    }, "api_media_get_medias_for_mounting": {
      "tokens": [
        [
          "text",
          "/video/videos/medias-for-mounting"
        ]
      ],
      "defaults": [],
      "requirements": [],
      "hosttokens": []
    },
    "api_media_convert_pdf_to_image": {
      "tokens": [
        [
          "text",
          "/video/video/pdf-to-image"
        ]
      ],
      "defaults": [],
      "requirements": [],
      "hosttokens": []
    },
    api_media_post_thumb_slide: {
      tokens: [['text', '/rich_media/rich_media/upload/thumb-slide']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_media_get_genersate_slide: {
      tokens: [['text', '/video/generate-slide']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_media_post_add_rich_media_video: {
      tokens: [['variable', '/', '\\d+', 'idVideo'], ['text', '/rich_media/add-rich-media-video']],
      defaults: [],
      requirements: {
        idVideo: '\\d+',
      },
      hosttokens: [],
    },
    api_media_get_options_video_player: {
      tokens: [
        ['text', '/options'],
        ['variable', '/', '[a-zA-Z0-9_+\\.=-]+', 'crypttext'],
        ['text', '/video/player'],
      ],
      defaults: [],
      requirements: {
        crypttext: '[a-zA-Z0-9_+\\.=-]+',
      },
      hosttokens: [],
    },
    api_media_get_generate_slide: {
      tokens: [['text', '/video/generate-slide']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_media_get_video_caption_by_language: {
      tokens: [
        ['text', '-language'],
        ['variable', '-', '[a-zA-Z_]+', 'lang'],
        ['text', '/captions-by'],
        ['variable', '/', '\\d+', 'id'],
        ['text', '/caption/video'],
      ],
      defaults: [],
      requirements: {
        id: '\\d+',
        lang: '[a-zA-Z_]+',
      },
      hosttokens: [],
    },
    api_media_post_generate_tmp_json: {
      tokens: [
        ['text', '/generate-tmp-json'],
        ['variable', '/', '\\d+', 'id'],
        ['text', '/caption/video'],
      ],
      defaults: [],
      requirements: {
        id: '\\d+',
      },
      hosttokens: [],
    },
    api_media_post_generate_caption: {
      tokens: [
        ['text', '/generate-caption'],
        ['variable', '/', '\\d+', 'id'],
        ['text', '/caption/video'],
      ],
      defaults: [],
      requirements: {
        id: '\\d+',
      },
      hosttokens: [],
    },
    api_media_get_video_captions_for_player: {
      tokens: [
        ['text', '/captions'],
        ['variable', '/', '\\d+', 'id'],
        ['text', '/caption/player/video'],
      ],
      defaults: [],
      requirements: {
        id: '\\d+',
      },
      hosttokens: [],
    },
    api_media_post_generate_caption_for_player: {
      tokens: [
        ['text', '/generate-caption'],
        ['variable', '/', '\\d+', 'id'],
        ['text', '/caption/player/video'],
      ],
      defaults: [],
      requirements: {
        id: '\\d+',
      },
      hosttokens: [],
    },
    api_media_add_error_player: {
      tokens: [['text', '/video/add-error-player']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    "api_media_get_number_visits": {
      "tokens": [
        [
          "text",
          "/video/video/number-visits"
        ]
      ],
      "defaults": [],
      "requirements": [],
      "hosttokens": []
    },
    "api_media_post_tmp_content_vtt": {
      "tokens": [
        [
          "text",
          "/caption/video/post-tmp-content-vtt"
        ]
      ],
      "defaults": [],
      "requirements": [],
      "hosttokens": []
    },
    "api_podcast_get_all_podcasts": {
      "tokens": [
        [
          "text",
          "/podcast/podcasts"
        ]
      ],
      "defaults": [],
      "requirements": [],
      "hosttokens": []
    },
    "api_media_get_permission_player": {
      "tokens": [
        [
          "variable",
          "/",
          "[a-zA-Z0-9_+\\.=-]+",
          "crypttext"
        ],
        [
          "text",
          "/video/permission-player"
        ]
      ],
      "defaults": [],
      "requirements": {
        "crypttext": "[a-zA-Z0-9_+\\.=-]+"
      },
      "hosttokens": []
    },
    "api_media_get_permission_player-caption": {
      "tokens": [
        [
          "variable",
          "/",
          "[a-zA-Z0-9_+\\.=-]+",
          "crypttext"
        ],
        [
          "text",
          "/video/permission-player-caption"
        ]
      ],
      "defaults": [],
      "requirements": {
        "crypttext": "[a-zA-Z0-9_+\\.=-]+"
      },
      "hosttokens": []
    },
    "api_media_get_media": {
      "tokens": [
        [
          "text",
          "/media/medias/list"
        ]
      ],
      "defaults": [],
      "requirements": [],
      "hosttokens": []
    },
    "api_media_post_video_attached_file": {
      "tokens": [
        [
          "text",
          "/video/video/upload/attached-file"
        ]
      ],
      "defaults": [],
      "requirements": [],
      "hosttokens": []
    },
    api_media_get_decrypted_infos: {
      tokens: [
        [
          "text",
          "/video/video/decrypt/infos"
        ]
      ],
      defaults: [],
      requirements: [],
      hosttokens: []
    },

  },
  prefix: '',
  host: 'localhost',
  scheme: 'http',
};



// WEBPACK FOOTER //
// ./src/core/router/fos_js_routes_export.js